import {
    Dialog,
    DialogContent,
} from '@/src/shadComponents/ui/dialog';

interface ModalProps {
    onDismiss: (id?: number) => void;
    cancelButtonRef?: React.RefObject<HTMLButtonElement>;
    children: React.ReactNode;
}

export default function Modal({
    onDismiss,
    cancelButtonRef,
    children,
}: ModalProps) {
    return (
        <Dialog open={true} onOpenChange={() => onDismiss()}>
            <DialogContent className="sm:max-w-lg">
                {children}
            </DialogContent>
        </Dialog>
    );
}
